import { Flex, PageContent, PageHeader } from '@/components';
import { SegmentSwitcher } from '@/features/project/_components/SegmentSwitcher';
import { useTranslation } from 'react-i18next';
import { InspectionResultTable } from '../_components/InspectionResultTable';
import { InspectionSearchForm } from '../_components/InspectionSearchForm';

export const InspectionPage = () => {
  const { t } = useTranslation();
  return (
    <>
      <PageHeader
        breadcrumbs={[{ title: t('projects-page') }]}
        title={t('project-inspection')}
      />
      <PageContent>
        <Flex vertical gap={16}>
          <SegmentSwitcher segment="projectInspection" />
          <InspectionSearchForm />
          <InspectionResultTable />
        </Flex>
      </PageContent>
    </>
  );
};
